export class AerolineaDestinoDTO {
    id:string;
    codigoAeroplanta:string;
    diaDesde: number;
    diaHasta: number;
    cuenta:string;
    codigoAeropuerto:string;
    numeroVuelo:string;
}
